// import React, { useState, useEffect } from "react";
// import { Link } from "react-router-dom";
// import axios from "axios";
// import { FaChevronRight, FaFire, FaPercent, FaBolt } from "react-icons/fa";
// import { motion, AnimatePresence } from "framer-motion";
// import { globalLogout } from "../../../Utils/Logout";
// const DealsPage = () => {
// 	const [categories, setCategories] = useState([]);
// 	const [discountedProducts, setDiscountedProducts] = useState([]);
// 	const [loading, setLoading] = useState(true);
// 	const [error, setError] = useState(null);
// 	const [featuredDeal, setFeaturedDeal] = useState(null);
// 	const [categoryDiscounts, setCategoryDiscounts] = useState({});
// 	const [categoryMap, setCategoryMap] = useState({});
// 	const [featuredCandidates, setFeaturedCandidates] = useState([]);

// 	const pickRandomFeaturedDeal = (categories) => {
// 		if (!categories || categories.length === 0) return null;

// 		const validCategories = categories.filter(c => c.subcategories?.length > 0);
// 		if (validCategories.length === 0) return null;

// 		const randomCategory =
// 			validCategories[Math.floor(Math.random() * validCategories.length)];

// 		const randomSubcategory =
// 			randomCategory.subcategories[
// 			Math.floor(Math.random() * randomCategory.subcategories.length)
// 			];

// 		return {
// 			...randomSubcategory,
// 			categoryName: randomCategory.name
// 		};
// 	};

// 	useEffect(() => {
// 		const fetchData = async () => {
// 			try {
// 				setLoading(true);

// 				// Fetch categories and discounted products simultaneously
// 				const [categoriesResponse, discountedResponse] = await Promise.all([
// 					axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/seller/category/list`),
// 					axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/seller/product/get-by-discount`)
// 				]);

// 				if (categoriesResponse.data.success) {
// 					const processedCategories = categoriesResponse.data.categories
// 						.filter(cat => cat.published)
// 						.map(category => {
// 							const topLevelSubs = (category.subcategories || [])
// 								.filter(sub => sub.published)
// 								.map(sub => ({
// 									...sub,
// 									price: Math.floor(Math.random() * 10000) + 1000,
// 									discount: 0 // Initialize with 0, will be updated later
// 								}));

// 							let allSubcategories = [...topLevelSubs];
// 							if (topLevelSubs.length < 6) {
// 								const getNestedSubs = (subs) => {
// 									let result = [];
// 									subs.forEach(sub => {
// 										if (sub.subcategories && sub.subcategories.length > 0) {
// 											const nested = sub.subcategories
// 												.filter(nestedSub => nestedSub.published)
// 												.map(nestedSub => ({
// 													...nestedSub,
// 													price: Math.floor(Math.random() * 10000) + 1000,
// 													discount: 0
// 												}));
// 											result = result.concat(nested);
// 										}
// 									});
// 									return result;
// 								};

// 								const nestedSubs = getNestedSubs(category.subcategories || []);
// 								const needed = 6 - topLevelSubs.length;
// 								allSubcategories = allSubcategories.concat(nestedSubs.slice(0, needed));
// 							}

// 							return {
// 								...category,
// 								subcategories: allSubcategories.slice(0, 6) // Limit to 6 subcategories
// 							};
// 						})
// 						.filter(category => category.subcategories.length > 0);

// 					setCategories(processedCategories);

// 					// Create a mapping of category IDs to category names for easier lookup
// 					const catMap = {};
// 					processedCategories.forEach(category => {
// 						catMap[category.id] = category.name;
// 						(category.subcategories || []).forEach(subcategory => {
// 							catMap[subcategory.id] = subcategory.name;
// 						});
// 					});
// 					setCategoryMap(catMap);

// 					setFeaturedCandidates(processedCategories);
// 					setFeaturedDeal(pickRandomFeaturedDeal(processedCategories));
// 				}

// 				// Process discounted products
// 				if (discountedResponse.data.success && discountedResponse.data.products) {
// 					setDiscountedProducts(discountedResponse.data.products);

// 					// Calculate max discount for each category
// 					const discounts = {};
// 					discountedResponse.data.products.forEach(product => {
// 						if (product.category && product.variants && product.variants.length > 0) {
// 							const categoryId = product.category;
// 							const discount = Math.max(...product.variants.map(v => v.discount || 0));

// 							if (!discounts[categoryId] || discount > discounts[categoryId]) {
// 								discounts[categoryId] = discount;
// 							}
// 						}
// 					});

// 					setCategoryDiscounts(discounts);
// 				}

// 				setLoading(false);
// 			} catch (error) {
// 				globalLogout(error)
// 				console.error("Error fetching data:", error);
// 				setError("Failed to load data. Please try again later.");
// 				setLoading(false);
// 			}
// 		};

// 		fetchData();
// 	}, []);

// 	useEffect(() => {
// 		if (!featuredCandidates.length) return;

// 		const INTERVAL_TIME = 8000;

// 		const interval = setInterval(() => {
// 			setFeaturedDeal(prev => {
// 				let next = pickRandomFeaturedDeal(featuredCandidates);

// 				// Avoid showing the same deal twice in a row
// 				if (prev && next?.id === prev.id) {
// 					next = pickRandomFeaturedDeal(featuredCandidates);
// 				}

// 				return next;
// 			});
// 		}, INTERVAL_TIME);

// 		return () => clearInterval(interval);
// 	}, [featuredCandidates]);

// 	// Function to get the maximum discount for a category
// 	const getCategoryDiscount = (categoryId) => {
// 		return categoryDiscounts[categoryId] || 0;
// 	};

// 	// Function to get discounted products for a specific category and its subcategories
// 	const getDiscountedProductsForCategoryTree = (category) => {
// 		const allCategoryIds = [category.id];

// 		// Recursively get all subcategory IDs
// 		const getSubcategoryIds = (subcategories) => {
// 			subcategories.forEach(sub => {
// 				allCategoryIds.push(sub.id);
// 				if (sub.subcategories && sub.subcategories.length > 0) {
// 					getSubcategoryIds(sub.subcategories);
// 				}
// 			});
// 		};

// 		if (category.subcategories && category.subcategories.length > 0) {
// 			getSubcategoryIds(category.subcategories);
// 		}

// 		return discountedProducts.filter(product =>
// 			allCategoryIds.includes(product.category)
// 		);
// 	};

// 	const generateTag = (discount, productCount) => {
// 		if (discount > 0) {
// 			return {
// 				text: `Upto ${discount}% off`,
// 				icon: <FaPercent className="mr-1" />,
// 				color: "bg-gradient-to-r from-red-500 to-orange-500 text-white"
// 			};
// 		}

// 		// Show tags even when there are no discounts but products exist
// 		if (productCount > 0) {
// 			const staticTags = [
// 				{ text: "Hot Deals", icon: <FaFire className="mr-1" />, color: "bg-gradient-to-r from-red-500 to-orange-500 text-white" },
// 				{ text: "Limited Time", icon: <FaBolt className="mr-1" />, color: "bg-gradient-to-r from-purple-500 to-pink-500 text-white" },
// 				{ text: "Popular", icon: <FaFire className="mr-1" />, color: "bg-gradient-to-r from-blue-500 to-cyan-500 text-white" },
// 				{ text: "Trending", icon: <FaBolt className="mr-1" />, color: "bg-gradient-to-r from-green-500 to-emerald-500 text-white" }
// 			];
// 			return staticTags[Math.floor(Math.random() * staticTags.length)];
// 		}

// 		return null;  // Only return null if there are no products at all
// 	};

// 	const getValidImageUrl = (url) => {
// 		if (!url) return "https://via.placeholder.com/150?text=No+Image";
// 		if (url.includes('google.com') || url.includes('googleusercontent') ||
// 			url.includes('www.google.com')) {
// 			return "https://via.placeholder.com/150?text=No+Image";
// 		}
// 		return url;
// 	};

// 	if (loading) {
// 		return (
// 			<motion.div
// 				initial={{ opacity: 0 }}
// 				animate={{ opacity: 1 }}
// 				className="bg-gradient-to-b from-gray-50 to-gray-100 py-12"
// 			>
// 				<div className="container mx-auto px-4 space-y-12">
// 					{[...Array(3)].map((_, i) => (
// 						<div key={i}>
// 							<div className="h-8 bg-gradient-to-r from-gray-200 to-gray-300 rounded-full w-1/4 mb-8 animate-pulse"></div>
// 							<div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6 gap-6">
// 								{[...Array(6)].map((_, j) => (
// 									<motion.div
// 										key={j}
// 										initial={{ opacity: 0.5 }}
// 										animate={{ opacity: 0.8 }}
// 										transition={{ repeat: Infinity, repeatType: "reverse", duration: 1, delay: j * 0.1 }}
// 										className="bg-gradient-to-br from-gray-100 to-gray-200 rounded-xl h-64 shadow-sm"
// 									></motion.div>
// 								))}
// 							</div>
// 						</div>
// 					))}
// 				</div>
// 			</motion.div>
// 		);
// 	}

// 	if (error) {
// 		return (
// 			<motion.div
// 				initial={{ opacity: 0 }}
// 				animate={{ opacity: 1 }}
// 				className="bg-gradient-to-b from-gray-50 to-gray-100 py-12 container mx-auto px-4 text-center"
// 			>
// 				<div className="max-w-md mx-auto bg-white p-8 rounded-xl shadow-lg">
// 					<div className="text-red-500 text-5xl mb-4">⚠️</div>
// 					<h3 className="text-xl font-bold text-gray-800 mb-2">Oops! Something went wrong</h3>
// 					<p className="text-gray-600 mb-6">{error}</p>
// 					<motion.button
// 						whileHover={{ scale: 1.05 }}
// 						whileTap={{ scale: 0.95 }}
// 						className="bg-gradient-to-r from-indigo-500 to-purple-600 text-white px-6 py-3 rounded-lg font-medium shadow-md"
// 						onClick={() => window.location.reload()}
// 					>
// 						Try Again
// 					</motion.button>
// 				</div>
// 			</motion.div>
// 		);
// 	}

// 	if (categories.length === 0) {
// 		return (
// 			<motion.div
// 				initial={{ opacity: 0 }}
// 				animate={{ opacity: 1 }}
// 				className="bg-gradient-to-b from-gray-50 to-gray-100 py-12 container mx-auto px-4 text-center"
// 			>
// 				<div className="max-w-md mx-auto bg-white p-8 rounded-xl shadow-lg">
// 					<div className="text-gray-400 text-5xl mb-4">🛍️</div>
// 					<h3 className="text-xl font-bold text-gray-800 mb-2">No Deals Available</h3>
// 					<p className="text-gray-600 mb-6">Check back later for exciting offers!</p>
// 					<Link to="/">
// 						<motion.button
// 							whileHover={{ scale: 1.05 }}
// 							whileTap={{ scale: 0.95 }}
// 							className="bg-gradient-to-r from-indigo-500 to-purple-600 text-white px-6 py-3 rounded-lg font-medium shadow-md"
// 						>
// 							Go to Home
// 						</motion.button>
// 					</Link>
// 				</div>
// 			</motion.div>
// 		);
// 	}

// 	return (
// 		<motion.div
// 			initial={{ opacity: 0 }}
// 			animate={{ opacity: 1 }}
// 			transition={{ duration: 0.5 }}
// 			className={`
// 				bg-gradient-to-b from-[#F4F1EA] via-[#EFEDE4] to-[#E5E1D3]
// 				py-12 md:py-20 
// 				relative 
// 				after:content-[''] after:absolute after:inset-0 
// 				after:bg-[url('https://www.transparenttextures.com/patterns/pinstriped-suit.png')] 
// 				after:opacity-[0.04] after:pointer-events-none
// 				shadow-[inset_0_0_100px_rgba(45,27,14,0.03)]
// 			`}
// 		>
// 			<div className="container mx-auto px-3 md:px-4 space-y-8 md:space-y-12">
// 				{/* Featured Deals Banner - Responsive adjustments */}
// 				<AnimatePresence mode="wait">
// 					{featuredDeal && (
// 						<motion.div
// 							key={featuredDeal.id}
// 							layout
// 							initial={false}
// 							animate={{ opacity: 1 }}
// 							exit={{ opacity: 1 }}
// 							transition={{
// 								layout: { duration: 0.35, ease: "easeOut" }
// 							}}
// 							className="relative bg-[#2D1B0E] rounded-sm p-6 md:p-12 text-[#FDFBF7] overflow-hidden shadow-2xl border border-stone-800"
// 						>
// 							{/* Decorative Wood Grain Pattern Overlay */}
// 							<div className="absolute inset-0 opacity-10 pointer-events-none bg-[url('https://www.transparenttextures.com/patterns/wood-pattern.png')]"></div>

// 							{/* Artistic Corner Brackets (Optional Inlay Effect) */}
// 							<div className="absolute top-4 left-4 w-8 h-8 border-t border-l border-yellow-700/50"></div>
// 							<div className="absolute bottom-4 right-4 w-8 h-8 border-b border-r border-yellow-700/50"></div>

// 							<div className="relative z-10 flex flex-col md:flex-row items-center">
// 								<div className="md:w-1/2 mb-8 md:mb-0">
// 									{/* Category Badge - Brass Plate Style */}
// 									<motion.div
// 										layout
// 										className="inline-block px-4 py-1.5 border border-yellow-600/40 bg-yellow-900/20 rounded-none text-[10px] md:text-xs font-bold tracking-[0.3em] uppercase mb-6 text-yellow-500"
// 									>
// 										{featuredDeal.categoryName}
// 									</motion.div>

// 									{/* Heading - Elegant Serif */}
// 									<motion.h3 layout className="text-2xl md:text-4xl lg:text-5xl font-serif mb-4 italic">
// 										{featuredDeal.name}
// 									</motion.h3>

// 									{/* Description - Light & Italic */}
// 									<motion.p
// 										layout
// 										className="mb-8 text-stone-300 text-opacity-80 max-w-md text-sm md:text-lg font-light italic leading-relaxed w-[80%] lg:w-full"
// 									>
// 										A masterpiece of craftsmanship. Experience the timeless quality of our hand-finished collection.
// 									</motion.p>

// 									{/* CTA Button - Polished Bone/White Oak Style */}
// 									<motion.div
// 										layout
// 									>
// 										<Link
// 											to={`/subcategory/${featuredDeal.slug}`}
// 											className="inline-flex items-center bg-[#FDFBF7] text-[#2D1B0E] px-6 py-3 md:px-10 md:py-4 rounded-sm font-bold tracking-widest uppercase text-xs md:text-sm hover:bg-yellow-50 transition-all duration-300 shadow-[4px_4px_0px_rgba(180,83,9,0.4)] hover:shadow-none hover:translate-x-[2px] hover:translate-y-[2px]"
// 										>
// 											Shop Now <FaChevronRight className="ml-3 text-[10px]" />
// 										</Link>
// 									</motion.div>
// 								</div>

// 								{/* Product Image Section */}
// 								<div className="md:w-1/2 flex justify-center items-center relative">
// 									<motion.div
// 										initial={{ scale: 0.9, opacity: 0 }}
// 										animate={{ scale: 1, opacity: 1 }}
// 										transition={{
// 											type: "spring",
// 											stiffness: 120,
// 											damping: 18,
// 											delay: 0.25,
// 										}}
// 										whileHover={{ scale: 1.02 }}
// 										className="relative"
// 									>
// 										{/* Soft Golden Glow behind product */}
// 										<div className="absolute inset-0 bg-yellow-600/10 rounded-full blur-[80px]"></div>

// 										<img
// 											layout
// 											src={getValidImageUrl(featuredDeal.media)}
// 											alt={featuredDeal.name}
// 											className="relative z-10 w-48 h-48 md:w-80 md:h-80 object-contain drop-shadow-[0_20px_50px_rgba(0,0,0,0.5)]"
// 										/>
// 									</motion.div>
// 								</div>
// 							</div>
// 						</motion.div>
// 					)}
// 				</AnimatePresence>

// 				{/* Category Sections */}
// 				<AnimatePresence>
// 					{categories.map((category, index) => {
// 						const categoryDiscount = getCategoryDiscount(category.id);
// 						const discountedProductsInCategory = getDiscountedProductsForCategoryTree(category);

// 						return (
// 							<motion.div
// 								key={category.id}
// 								initial={{ opacity: 0, y: 30 }}
// 								animate={{ opacity: 1, y: 0 }}
// 								transition={{ delay: index * 0.1, type: "spring" }}
// 								/* Switched to a warm Bone White background and chiseled corners */
// 								className="bg-[#FDFBF7] p-4 md:p-6 lg:p-8 rounded-sm shadow-sm border border-stone-200 overflow-hidden relative"
// 							>
// 								{/* Subtle Wood Grain Overlay */}
// 								<div className="absolute inset-0 opacity-[0.02] pointer-events-none bg-[url('https://www.transparenttextures.com/patterns/pinstriped-suit.png')]"></div>

// 								{/* Section Header */}
// 								<div className="flex justify-between items-center mb-6 md:mb-8 relative z-10">
// 									<div className="flex items-center">
// 										<motion.h2
// 											whileHover={{ x: 5 }}
// 											/* Serif font for an artisan feel */
// 											className="md:text-xl lg:text-2xl font-serif font-bold text-stone-900 flex items-center italic"
// 										>
// 											{/* Brass Marker instead of Indigo Gradient */}
// 											<span className="w-1.5 h-6 md:w-2 md:h-8 bg-yellow-700 mr-3 md:mr-4 shadow-sm"></span>
// 											{category.name}
// 										</motion.h2>

// 										{/* Discount Badge - Wax Seal / Burnt Wood style */}
// 										{categoryDiscount > 0 && (
// 											<motion.div
// 												initial={{ scale: 0 }}
// 												animate={{ scale: 1 }}
// 												className="ml-3 bg-[#7A2B1A] text-[#FDFBF7] px-3 py-0.5 rounded-none text-[10px] md:text-xs font-bold uppercase tracking-widest flex items-center shadow-md"
// 											>
// 												<FaPercent className="mr-1 text-[8px]" /> {categoryDiscount}% OFF
// 											</motion.div>
// 										)}
// 									</div>

// 									<Link
// 										to={`/category/${category.slug}`}
// 										/* Stone tones and wide tracking for a premium look */
// 										className="flex items-center text-stone-500 font-bold uppercase tracking-widest hover:text-yellow-800 transition-colors group text-[10px] md:text-xs"
// 									>
// 										<motion.span
// 											animate={{ x: [0, 3, 0] }}
// 											transition={{ repeat: Infinity, duration: 2 }}
// 											className="mr-1 md:mr-2"
// 										>
// 											View All
// 										</motion.span>
// 										<FaChevronRight className="text-[8px] group-hover:translate-x-1 transition-transform" />
// 									</Link>
// 								</div>

// 								{/* Subcategories Grid */}
// 								<div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4 lg:gap-6 relative z-10">
// 									{category.subcategories.map((subcategory) => {
// 										const subcategoryProducts = discountedProducts.filter(
// 											product => product.category === subcategory.id
// 										);

// 										const subcategoryDiscount = subcategoryProducts.length > 0
// 											? Math.max(...subcategoryProducts.map(p =>
// 												Math.max(...p.variants.map(v => v.discount || 0))
// 											))
// 											: 0;

// 										const productCount = subcategoryProducts.length;
// 										const tag = generateTag(subcategoryDiscount, productCount);

// 										return (
// 											<motion.div
// 												key={subcategory.id}
// 												initial={{ opacity: 0, scale: 0.9 }}
// 												animate={{ opacity: 1, scale: 1 }}
// 												transition={{ type: "spring" }}
// 												whileHover={{ y: -4 }}
// 												className="relative"
// 											>
// 												<Link
// 													to={`/subcategory/${subcategory.slug}`}
// 													className="group p-3 md:p-4 rounded-sm transition-all duration-300 flex flex-col h-full bg-white relative z-10 border border-stone-100 hover:border-yellow-800/30 hover:shadow-xl"
// 												>
// 													{/* Image Container - "The Pedestal" */}
// 													<div className="w-full h-40 sm:h-40 md:h-44 lg:h-52 xl:h-80 overflow-hidden flex items-center justify-center bg-[#F9F7F2]">
// 														<motion.img
// 															src={getValidImageUrl(subcategory.media)}
// 															alt={subcategory.name}
// 															className="max-h-[85%] max-w-[85%] object-contain transition-transform duration-700 group-hover:scale-110"
// 															initial={{ opacity: 0 }}
// 															animate={{ opacity: 1 }}
// 															transition={{ duration: 0.5 }}
// 														/>
// 													</div>

// 													<div className="flex flex-col mt-auto text-center">
// 														{/* Product Title */}
// 														<h3 className="text-xs md:text-sm font-bold text-stone-800 mb-2 line-clamp-2 text-center group-hover:text-yellow-900 transition-colors leading-tight uppercase tracking-tight">
// 															{subcategory.name}
// 														</h3>

// 														{/* Subcategory Discount Badge */}
// 														{subcategoryDiscount > 0 && (
// 															<motion.div
// 																initial={{ scale: 0 }}
// 																animate={{ scale: 1 }}
// 																className="text-center mt-auto"
// 															>
// 																<span className="inline-block border border-red-800 text-red-800 text-[9px] md:text-[10px] font-bold px-2 py-0.5 uppercase tracking-tighter">
// 																	Save {subcategoryDiscount}%
// 																</span>
// 															</motion.div>
// 														)}

// 														{/* Promotional Tag */}
// 														{tag && subcategoryDiscount === 0 && (
// 															<motion.div className="text-center mt-auto">
// 																<div className="text-[9px] md:text-[10px] text-stone-400 font-bold uppercase tracking-widest flex items-center justify-center">
// 																	<span className="w-4 h-[1px] bg-stone-200 mr-2"></span>
// 																	{tag.text}
// 																	<span className="w-4 h-[1px] bg-stone-200 ml-2"></span>
// 																</div>
// 															</motion.div>
// 														)}
// 													</div>
// 												</Link>
// 											</motion.div>
// 										);
// 									})}
// 								</div>
// 							</motion.div>
// 						);
// 					})}
// 				</AnimatePresence>
// 			</div>
// 		</motion.div>
// 	);
// };

// export default DealsPage;





















import React, { useState, useEffect, useMemo } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { FaChevronRight } from "react-icons/fa";
import { ArrowRight, ShoppingBag } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import { globalLogout } from "../../../Utils/Logout";
import fallbackImage from "../../../assets/brand-default.jpg";

const ROTATE_MS = 8000;
const MAX_TILES = 6;

const getValidImageUrl = (url) =>
	!url || /google\.com|googleusercontent/.test(url) ? fallbackImage : url;

// pick a random subcategory, optionally avoiding the one currently shown
const pickRandomFeaturedDeal = (categories, excludeId) => {
	const valid = (categories || []).filter((c) => c.subcategories?.length > 0);
	if (valid.length === 0) return null;

	let pick = null;
	for (let i = 0; i < 6; i++) {
		const cat = valid[Math.floor(Math.random() * valid.length)];
		const sub = cat.subcategories[Math.floor(Math.random() * cat.subcategories.length)];
		pick = { ...sub, categoryName: cat.name };
		if (pick.id !== excludeId) break;
	}
	return pick;
};

const DealsPage = () => {
	const [categories, setCategories] = useState([]);
	const [discountedProducts, setDiscountedProducts] = useState([]);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);
	const [featuredDeal, setFeaturedDeal] = useState(null);

	/* ---------- data ---------- */
	useEffect(() => {
		const fetchData = async () => {
			try {
				setLoading(true);
				const [categoriesResponse, discountedResponse] = await Promise.all([
					axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/seller/category/list`),
					axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/seller/product/get-by-discount`),
				]);

				if (categoriesResponse.data.success) {
					const processed = categoriesResponse.data.categories
						.filter((cat) => cat.published)
						.map((category) => {
							const topLevel = (category.subcategories || []).filter((sub) => sub.published);
							let tiles = [...topLevel];

							// not enough direct children -> top up with nested ones
							if (topLevel.length < MAX_TILES) {
								const nested = [];
								(category.subcategories || []).forEach((sub) => {
									(sub.subcategories || []).forEach((n) => {
										if (n.published) nested.push(n);
									});
								});
								tiles = tiles.concat(nested.slice(0, MAX_TILES - topLevel.length));
							}

							return { ...category, subcategories: tiles.slice(0, MAX_TILES) };
						})
						.filter((category) => category.subcategories.length > 0);

					setCategories(processed);
					setFeaturedDeal(pickRandomFeaturedDeal(processed));
				}

				if (discountedResponse.data.success && discountedResponse.data.products) {
					setDiscountedProducts(discountedResponse.data.products);
				}
			} catch (err) {
				globalLogout(err);
				console.error("Error fetching data:", err);
				setError("Failed to load data. Please try again later.");
			} finally {
				setLoading(false);
			}
		};
		fetchData();
	}, []);

	// rotate the featured banner
	useEffect(() => {
		if (!categories.length) return;
		const id = setInterval(() => {
			setFeaturedDeal((prev) => pickRandomFeaturedDeal(categories, prev?.id));
		}, ROTATE_MS);
		return () => clearInterval(id);
	}, [categories]);

	/* ---------- best discount per category id ---------- */
	const discountById = useMemo(() => {
		const map = {};
		discountedProducts.forEach((product) => {
			if (!product.category || !product.variants?.length) return;
			const best = Math.max(...product.variants.map((v) => v.discount || 0));
			if (!map[product.category] || best > map[product.category]) map[product.category] = best;
		});
		return map;
	}, [discountedProducts]);

	const getCategoryDiscount = (category) =>
		Math.max(
			discountById[category.id] || 0,
			...category.subcategories.map((s) => discountById[s.id] || 0)
		);

	/* ---------- states ---------- */
	if (loading) {
		return (
			<section id="categories" className="bg-[#FBF7F0] py-10 md:py-14">
				<div className="mx-auto max-w-[1320px] px-3 sm:px-4 space-y-6 animate-pulse">
					<div className="h-64 rounded-2xl bg-yellow-900/10" />
					{[0, 1].map((i) => (
						<div key={i} className="rounded-lg bg-white border border-gray-200 p-5">
							<div className="h-6 w-1/4 bg-gray-200 rounded mb-5" />
							<div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
								{Array.from({ length: 6 }).map((_, j) => (
									<div key={j} className="h-44 bg-gray-100 rounded-lg" />
								))}
							</div>
						</div>
					))}
				</div>
			</section>
		);
	}

	if (error) {
		return (
			<section id="categories" className="bg-[#FBF7F0] py-12">
				<div className="mx-auto max-w-md rounded-lg border border-gray-200 bg-white p-8 text-center">
					<h3 className="text-lg font-semibold text-gray-900">Something went wrong</h3>
					<p className="mt-1 text-sm text-gray-600">{error}</p>
					<button
						type="button"
						onClick={() => window.location.reload()}
						className="mt-5 rounded-md bg-yellow-800 px-5 py-2 text-sm font-semibold text-white hover:bg-yellow-900"
					>
						Try again
					</button>
				</div>
			</section>
		);
	}

	if (categories.length === 0) {
		return (
			<section id="categories" className="bg-[#FBF7F0] py-12">
				<div className="mx-auto max-w-md rounded-lg border border-gray-200 bg-white p-8 text-center">
					<ShoppingBag className="mx-auto h-12 w-12 text-gray-300" />
					<h3 className="mt-3 text-lg font-semibold text-gray-900">No deals available</h3>
					<p className="mt-1 text-sm text-gray-600">Check back later for exciting offers!</p>
				</div>
			</section>
		);
	}

	/* ---------- main ---------- */
	return (
		<section id="categories" className="bg-[#FBF7F0] py-10 md:py-14 scroll-mt-4">
			<div className="mx-auto max-w-[1320px] px-3 sm:px-4 space-y-8">
				{/* Featured deal banner */}
				<AnimatePresence mode="wait">
					{featuredDeal && (
						<motion.div
							key={featuredDeal.id}
							initial={{ opacity: 0, y: 10 }}
							animate={{ opacity: 1, y: 0 }}
							exit={{ opacity: 0, y: -10 }}
							transition={{ duration: 0.35 }}
							className="relative overflow-hidden rounded-2xl bg-yellow-950 text-white"
						>
							<div className="absolute -right-16 -top-16 h-64 w-64 rounded-full bg-yellow-700/20 blur-3xl" />
							<div className="relative grid md:grid-cols-2 items-center gap-6 p-6 sm:p-8 md:p-12">
								<div>
									<span className="inline-block rounded-full bg-white/10 px-3 py-1 text-xs font-semibold uppercase tracking-wider text-yellow-200">
										{featuredDeal.categoryName}
									</span>
									<h3 className="mt-4 text-2xl md:text-4xl font-bold leading-tight">
										{featuredDeal.name}
									</h3>
									<p className="mt-3 max-w-md text-sm md:text-base text-yellow-50/80 leading-relaxed">
										A masterpiece of craftsmanship. Experience the timeless quality of our
										hand-finished collection.
									</p>
									<Link
										to={`/subcategory/${featuredDeal.slug}`}
										className="mt-6 inline-flex items-center gap-2 rounded-md bg-white px-6 py-3 text-sm font-semibold text-yellow-900 hover:bg-yellow-50 transition-colors"
									>
										Shop Now <ArrowRight size={16} />
									</Link>
								</div>

								<div className="flex justify-center">
									<img
										src={getValidImageUrl(featuredDeal.media)}
										alt={featuredDeal.name}
										className="h-48 w-48 md:h-72 md:w-72 rounded-xl object-contain drop-shadow-2xl"
									/>
								</div>
							</div>
						</motion.div>
					)}
				</AnimatePresence>

				{/* Category sections */}
				{categories.map((category) => {
					const categoryDiscount = getCategoryDiscount(category);

					return (
						<div
							key={category.id}
							className="rounded-lg border border-gray-200 bg-white p-4 sm:p-6"
						>
							<div className="mb-5 flex items-center justify-between gap-3">
								<div className="flex min-w-0 items-center gap-3">
									<span className="h-6 w-1 shrink-0 rounded-full bg-yellow-800" />
									<h2 className="truncate text-lg md:text-xl font-semibold text-gray-900">
										{category.name}
									</h2>
									{categoryDiscount > 0 && (
										<span className="shrink-0 rounded-full bg-green-50 px-2.5 py-0.5 text-xs font-semibold text-green-700">
											Up to {categoryDiscount}% off
										</span>
									)}
								</div>

								<Link
									to={`/category/${category.slug}`}
									className="flex shrink-0 items-center gap-1 text-sm font-semibold text-yellow-800 hover:underline"
								>
									View all <FaChevronRight className="text-[10px]" />
								</Link>
							</div>

							<div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 sm:gap-4">
								{category.subcategories.map((sub) => {
									const discount = discountById[sub.id] || 0;

									return (
										<Link
											key={sub.id}
											to={`/subcategory/${sub.slug}`}
											className="group flex flex-col overflow-hidden rounded-lg border border-gray-200 bg-white hover:border-yellow-800/40 hover:shadow-md transition-all"
										>
											<div className="relative flex h-36 sm:h-40 items-center justify-center bg-gray-50">
												<img
													src={getValidImageUrl(sub.media)}
													alt={sub.name}
													loading="lazy"
													className="max-h-full max-w-full object-contain p-3 transition-transform duration-500 group-hover:scale-105"
												/>
												{discount > 0 && (
													<span className="absolute left-0 top-0 rounded-br-md bg-green-600 px-2 py-1 text-[10px] font-semibold text-white">
														{discount}% off
													</span>
												)}
											</div>
											<div className="p-3 text-center">
												<h3 className="line-clamp-2 text-sm font-medium text-gray-800 group-hover:text-yellow-800 transition-colors">
													{sub.name}
												</h3>
											</div>
										</Link>
									);
								})}
							</div>
						</div>
					);
				})}
			</div>
		</section>
	);
};

export default DealsPage;